/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ElasticsearchClusterInformationResponse } from './';
import {
    ElasticsearchClusterInformationResponseFromJSON,
    ElasticsearchClusterInformationResponseFromJSONTyped,
    ElasticsearchClusterInformationResponseToJSON,
} from './';
import type { IndexStatusResponse } from './';
import {
    IndexStatusResponseFromJSON,
    IndexStatusResponseFromJSONTyped,
    IndexStatusResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface AdminInformationResponse
 */
export interface AdminInformationResponse {
    /**
     * 
     * @type {ElasticsearchClusterInformationResponse}
     * @memberof AdminInformationResponse
     */
    cluster: ElasticsearchClusterInformationResponse;
    /**
     * 
     * @type {Array<IndexStatusResponse>}
     * @memberof AdminInformationResponse
     */
    freelanceProfileIndicesStatus: Array<IndexStatusResponse>;
    /**
     * 
     * @type {Array<IndexStatusResponse>}
     * @memberof AdminInformationResponse
     */
    freelanceProfileES9SynonymsIndicesStatus: Array<IndexStatusResponse>;
    /**
     * 
     * @type {Array<IndexStatusResponse>}
     * @memberof AdminInformationResponse
     */
    suggestionIndicesStatus: Array<IndexStatusResponse>;
    /**
     * 
     * @type {IndexStatusResponse}
     * @memberof AdminInformationResponse
     */
    companyIndexStatus: IndexStatusResponse;
}

/**
 * Check if a given object implements the AdminInformationResponse interface.
 */
export function instanceOfAdminInformationResponse(value: object): value is AdminInformationResponse {
    if (!('cluster' in value) || value['cluster'] === undefined) return false;
    if (!('freelanceProfileIndicesStatus' in value) || value['freelanceProfileIndicesStatus'] === undefined) return false;
    if (!('freelanceProfileES9SynonymsIndicesStatus' in value) || value['freelanceProfileES9SynonymsIndicesStatus'] === undefined) return false;
    if (!('suggestionIndicesStatus' in value) || value['suggestionIndicesStatus'] === undefined) return false;
    if (!('companyIndexStatus' in value) || value['companyIndexStatus'] === undefined) return false;
    return true;
}

export function AdminInformationResponseFromJSON(json: any): AdminInformationResponse {
    return AdminInformationResponseFromJSONTyped(json, false);
}

export function AdminInformationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminInformationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'cluster': ElasticsearchClusterInformationResponseFromJSON(json['cluster']),
        'freelanceProfileIndicesStatus': ((json['freelanceProfileIndicesStatus'] as Array<any>).map(IndexStatusResponseFromJSON)),
        'freelanceProfileES9SynonymsIndicesStatus': ((json['freelanceProfileES9SynonymsIndicesStatus'] as Array<any>).map(IndexStatusResponseFromJSON)),
        'suggestionIndicesStatus': ((json['suggestionIndicesStatus'] as Array<any>).map(IndexStatusResponseFromJSON)),
        'companyIndexStatus': IndexStatusResponseFromJSON(json['companyIndexStatus']),
    };
}

export function AdminInformationResponseToJSON(value?: AdminInformationResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'cluster': ElasticsearchClusterInformationResponseToJSON(value['cluster']),
        'freelanceProfileIndicesStatus': ((value['freelanceProfileIndicesStatus'] as Array<any>).map((v) => IndexStatusResponseToJSON(v))),
        'freelanceProfileES9SynonymsIndicesStatus': ((value['freelanceProfileES9SynonymsIndicesStatus'] as Array<any>).map((v) => IndexStatusResponseToJSON(v))),
        'suggestionIndicesStatus': ((value['suggestionIndicesStatus'] as Array<any>).map((v) => IndexStatusResponseToJSON(v))),
        'companyIndexStatus': IndexStatusResponseToJSON(value['companyIndexStatus']),
    };
}

